import { ChangeDetectorRef, Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormControl, Validators, FormGroup, ValidatorFn, AbstractControl, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router,ActivatedRoute } from '@angular/router';
import { VerifyOtpComponent } from '../verify-otp/verify-otp.component';
import { AuthFacadeService } from 'src/app/modules/auth/state/auth/auth.facade.service';
import { NotificationService } from 'src/app/services/notification.service';
import { CryptoService } from 'src/app/services/crypto.service';
import { AuthService } from '../services/auth.service';
import { PopupMessageComponent } from '../../navigation/popup-message/popup-message.component';
import { Constants } from 'src/app/common/constants/constants';
import { CookieService } from 'src/app/services/cookie.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Subscription } from 'rxjs';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { ModalWindowService } from 'src/app/modules/shared/modal-window/modal-window-service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  @ViewChild('ngMobileOtpInput') ngMobileOtpInputRef: any;
  emailFormControl = new FormControl('', [Validators.required, Validators.email]);
  sendotp: boolean = false;
  otp!: string;
  verifyOtp: boolean = false;
  errorMsg!: string;
  form!: FormGroup;
  formSubmit: boolean = false;
  storeData: any ;
  encryptedToken : any;
  counter:any;
  ref_code:any = null;
  flag:boolean = false;
  disableResend:boolean = true;
  disableTimer: boolean = false;
  timer : any;
  mobileValidation:boolean = false;
  isMobile : boolean = false;
  isMail : boolean = false;
  timeout:any=Constants.POPUP_TIMEOUT;
  NO_SPECIAL_CHAR = new RegExp(/^[a-zA-Z0-9.]+$/);
  emailValidation = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  mobValidation = new RegExp(/^[0-9]{10}$/)
  MOB = new RegExp(/[6-9]/);
  NUM = new RegExp(/[0-9]/);
  isPassword: boolean = false;
  generateOTPSubscription = new Subscription();
  verifyOTPSubscription = new Subscription();
  loginSubscription = new Subscription();

  constructor(private authFacadeService : AuthFacadeService, private router: Router, public dialog: MatDialog,
              private notificationService : NotificationService, private cryptoService:CryptoService,
              private formBuilder: FormBuilder, private authService: AuthService,
              private route:ActivatedRoute,private utilsService : UtilsService,
              private cookieService : CookieService,private modalService: ModalWindowService) {
                this.authService.showOTP.subscribe((response:any)=>{
                  this.sendotp = response;
                })
              }

  config = {
    allowNumbersOnly: true,
    length: 6,
    inputStyles: {
      fontSize:'25px'
    },
  };

  // validateInput(c:FormControl){
  //   return (this.NO_SPECIAL_CHAR.test(c.value)||(this.emailValidation.test(c.value)||this.mobValidation.test(c.value)))?null:{
  //     validateInput:{
  //       valid:false
  //     }
  //   };
  // }
  ngOnInit(): void {
    localStorage.clear();
    this.route.queryParams.subscribe(parmas=>{
      console.log("GOT Refereal code",parmas['referral_code']);
      this.ref_code = parmas['referral_code'] || null;
    });
    localStorage.setItem('referral',String(this.ref_code));

    this.ref_code = localStorage.getItem('referral');
    this.generateOTPSubscription = this.authFacadeService.getGenerateOTPResult$.subscribe((stores : any) => {
      this.storeData = stores;
      if(this.storeData && this.storeData.generateOTPResponse){
        this.sendotp = true;
        this.flag = true;
      }
      else if(this.storeData && this.storeData.response.errorMessage){
        const popup = this.dialog.open(PopupMessageComponent,{
          data:{
            title:"Error",
            message:this.storeData.response.errorMessage.error.message
          }
        })
        popup.afterOpened().subscribe(res=>{
          setTimeout(()=>{
            popup.close();
          }, this.timeout)
        })
        // this.notificationService.showError(this.storeData.response.errorMessage.error.message, "Error");
      }
    });

    this.verifyOTPSubscription = this.authFacadeService.getVerifyOTPResult$.subscribe((stores : any) => {
      this.storeData = stores;
      if(this.storeData && this.storeData.response.verifyOTPResponse){
        this.encryptedToken = this.cryptoService.encrypt(this.storeData.response.verifyOTPResponse.token);
        //localStorage.setItem('token', this.encryptedToken);
        this.cookieService.setCookie('token', this.encryptedToken);
        if(window.location.href.includes('ifa'))
        {
          //this.router.navigate(['/ifa/dashboard']);
          this.router.navigate(['/ifa/dashboard/invest']);
        }
        else{
          //this.router.navigate(['/dashboard']);
          this.router.navigate(['/dashboard/invest']);
          //this.router.navigate(['/onboarding']);
        }
      }
      else if(this.storeData && this.storeData.response.verifyOTPErrorMessage){
        const popup = this.dialog.open(PopupMessageComponent,{
          data:{
            title:"Error",
            message:this.storeData.response.verifyOTPErrorMessage.error.message
          }
        })
        popup.afterOpened().subscribe(res=>{
          setTimeout(()=>{
            popup.close();
          }, this.timeout)
        })
        // this.notificationService.showError(this.storeData.response.verifyOTPErrorMessage.error.message, "Error");
      }
    });


    this.loginSubscription = this.authFacadeService.getLoginResult$.subscribe((stores : any) => {
      this.storeData = stores;
      if(this.storeData && this.storeData.response.loginResponse){
        let encryptedToken : any = this.cryptoService.encrypt(this.storeData.response.loginResponse.token);
        this.cookieService.setCookie('token', encryptedToken);
        this.authService.fetchUser().subscribe((res : any) => {
            console.log('user',res)
            if(res && res.data && res.data.personal_details){
            const username = `${res.data.personal_details.first_name} ${res.data.personal_details.last_name}`;
            let encryptedRefUrl : any = res.data.personal_details.referral_link ? this.cryptoService.encrypt(res.data.personal_details.referral_link) : res.data.personal_details.referral_link;
            this.utilsService.onUserUpdate.next({username : username, referral_link : res.data.personal_details.referral_link});
            localStorage.setItem('username', username);
            localStorage.setItem('referral_link', encryptedRefUrl);
            let encryptedUserId : any = this.cryptoService.encrypt(res.data.personal_details.user_id);
            localStorage.setItem('userId', encryptedUserId);
            if(window.location.href.includes('ifa'))
              {
                //this.router.navigate(['/ifa/dashboard']);
                this.router.navigate(['/ifa/dashboard/invet']);
              }
              else{
                //this.router.navigate(['/dashboard']);
                this.router.navigate(['/dashboard/invest']);
                //this.router.navigate(['/onboarding']);
              }
            }
          });

      }
      else if(this.storeData && this.storeData.response.loginErrorMessage){

        const errorPopup = this.dialog.open(PopupMessageComponent,{
          data:{
            title:"Error",
            message:this.storeData.response.loginErrorMessage.error ?
                this.storeData.response.loginErrorMessage.error.message : 'Error on login'
          }
        })
        errorPopup.afterOpened().subscribe((res : any)=>{
          setTimeout(()=>{
            errorPopup.close();
          }, this.timeout)
        })
        // this.notificationService.showError(this.storeData.response.errorMessage.error.message, "Error");
      }
    });

    this.form = this.formBuilder.group({
      mobileOrEmail: new FormControl('', [Validators.required,Validators.pattern(/^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4}))$/)]),
      userPassword: new FormControl('', [Validators.required])
    },
    {
      validator : EmailMobileValidator('mobileOrEmail')
    }
  );
  }

  submit() {
    this.formSubmit = true;
    localStorage.clear();
    if( this.form.value.mobileOrEmail){
      let fieldVal =  this.form.value.mobileOrEmail;
      if (fieldVal != '' && !this.flag) {
        let type = 1
        if(window.location.href.includes('ifa')){
          type = 3
        }
          this.authFacadeService.generateOTP(fieldVal, type)
          this.flag=true;
          this.setTimer()
          this.disableTimer = false;
          this.disableResend = true;
          // this.sendotp = true;
      }
    }
  }

  onMobileOtpChange(otp: string) {
    this.otp = otp;
    if (otp.length === 6) {
    this.verifyOtp = true;
    this.errorMsg = "";
    } else {
      this.verifyOtp = false;
      // this.errorMsg = "Please enter valid OTP";
    }
  }
  openRegisign(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
}


  verify() {
    // console.log("Referral Code",this.ref_code);
    let type = 1
    if(window.location.href.includes('ifa')){
      type = 3
    }
    this.authFacadeService.verifyOTP(this.form.value.mobileOrEmail , this.otp, type,this.ref_code == "null" ? null : this.ref_code)
    // if( this.verifyOtp == true) {
    //   this.router.navigateByUrl('/onbording');
    // } else {
    //   this.verifyOtp = false;
    //   this.errorMsg = "Please enter valid otp";
    // }
  }
  public checkMobileOrMail(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const input = control.value;
      let emailregx = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      let mobileregx = /^(\+\d{1,3}[- ]?)?\d{10}$/;
      let valid: boolean = emailregx.test(input) || mobileregx.test(input) ;

      return !valid ? { typeError: { valid } } : {};
    };
  }

  checkValid(e:any,text:any):any{
    let key = e.key;
    if(text==='mob'){
      let mob = this.form.controls['mobileOrEmail'].value;
      if(mob.length === 0){
        if(this.MOB.test(key)===true){
          return true;
        }
        else{
          return false;
        }
      }
      else{
        if(this.NUM.test(key)===true){
          return true;
        }
        else{
          return false;
        }
      }
    }
  }

  keyPressNumbers(event : any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  forgot_password() {
    if(this.form.value.mobileOrEmail){
      let type = 1
      if(window.location.href.includes('ifa')){
        type = 3
      }
      const data = {
        "email" : this.form.value.mobileOrEmail,
        "type" : type,
      }
      const promise = this.authService.forgotPassword(data)

      promise.then((res : any) => {
        const popup = this.dialog.open(ForgotPasswordComponent);
        popup.afterOpened().subscribe(res=>{
          setTimeout(()=>{
            popup.close();
          }, this.timeout)
        })
      })
      .catch((error : any) => {
          const popup = this.dialog.open(PopupMessageComponent,{
            data:{
              title:"Error",
              message:error.error.message
            }
          })
          popup.afterOpened().subscribe(res=>{
            setTimeout(()=>{
              popup.close();
            }, this.timeout)
          })
      })
    }
  }

  onFocusOutEvent(event : any) {
    this.isMobile = false;
    this.isMail = false;
    if(this.form.value.mobileOrEmail)
    if (this.emailValidation.test(this.form.value.mobileOrEmail))
    {
      this.isMail = true;
    }
    if (this.mobValidation.test(this.form.value.mobileOrEmail))
    {
      this.isMobile = true;
    }

    event.preventDefault();
    return;
  }

  onChangeEvent(event : any){
    this.mobileValidation = false;
    if(!this.mobValidation.test(this.form.value.mobileOrEmail))
    {
      event.preventDefault();
      this.mobileValidation = true
      return;
    }

  }

  terms(){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/tnc'])
    );
    window.open(url, '_blank');
  }

  setTimer() {
    let seconds: number = 1 * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    let sec:number = 60;

    const prefix = 1 < 10 ? "0" : "";

      this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.counter = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        clearInterval(this.timer);
        this.disableResend =false;
        this.disableTimer = true;
        this.flag=false;
      }
    }, 1000);
  }

  goBack() {
    this.sendotp = false;
    this.disableResend =false;
    this.disableTimer = true;
    this.flag=false;
    clearInterval(this.timer);
  }

  ngAfterViewInit(): void {
    if(!window.location.href.includes('ifa')){
      this.openRegisign('certificatemodal-regis')
    }
  }

  ngOnDestroy() : void{
    this.generateOTPSubscription.unsubscribe();
    this.verifyOTPSubscription.unsubscribe();
    this.loginSubscription.unsubscribe();
    this.authFacadeService.clearState();
  }

  withPassword() {
    let type = 1
    if(window.location.href.includes('ifa')){
      type = 3
    }
    this.isPassword = true;
    if(this.form.value.mobileOrEmail && this.form.value.userPassword){
      const data = {
        "email" : this.form.value.mobileOrEmail,
        "type" : type,
        "password" : this.form.value.userPassword,
        "referred_by" : this.ref_code,
        "utmDetails": {
            "utmSource": "",
            "utmMedium" :"",
            "utmCampaign": ""
        }
    }
      this.authFacadeService.login(data);
    }
  }
}

export function NoWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): any => {
      window.setTimeout(() => {
          if (control.value && control.value != '') {
              let trimedvalue = control.value.replace(/\s/g, '');
              control.setValue(trimedvalue);
          }
      }, 10);
  };
}

export function EmailMobileValidator (
  mobileOrEmail: string
) {
  return (formGroup: FormGroup) => {
    let MOB = new RegExp(/[6-9]/);
    let mobileVal = new RegExp(/^[0-9]{10}$/)
    const mobileOrEmailControl = formGroup.controls[mobileOrEmail];
    if (mobileOrEmailControl.value) {
        const mobNumber = Number(mobileOrEmailControl.value);
        if(mobNumber){
          if( mobileOrEmailControl.value.length == 10){
            const firstNum = mobileOrEmailControl.value.charAt(0)
            if(!MOB.test(firstNum)){
              mobileOrEmailControl.setErrors({ isMobileInValid : true });
            }
          }
          else if(!mobileVal.test(mobileOrEmailControl.value))
          {
            mobileOrEmailControl.setErrors({ isMobileInValid : true });
          }
        }
    } else {
      mobileOrEmailControl.setErrors(null);
    }

    return;
  };
}
